import clampEnedisCarToMinimum, { clampCarMessage } from '../Consumption/Utilities/clampEnedisCarToMinimum'

export const updateEnedisRawDataMeterOption = meterInformation => {
  const validHPHCMeterOptions = [
    'Heures Pleines/Creuses',
    'Option Week-End',
    'Heures Super Creuses',
    'hphc Weekend',
    'hphc Saison Haute/Basse',
    'HC Semaine et HC Week-End et HC Vendredi',
    'PART ELEC WE HPHC',
    'HC Semaine et HC Week-End',
    'Heures Pleines/Creuses Saison Haute/Basse',
    'Option Heures Creuses + Week-End',
    'Heures Pleines/Creuses Weekend',
    'HC Semaine et HC Week-End et HC Lundi',
    'HC Semaine et HC Week-End et HC Mercredi',
    'Semaine Week-End et Lundi',
    'Semaine Week-End et Vendredi',
    'Semaine Week-End et Mercredi',
    'tempo',
    'EFFACEMENT_HPHC_2',
    'Heures Pleines/Creuses Semaine/Week-end',
    'Heures Pleines Heures Creuses Pointe Mobile',
    'MCP - Offre Pointe Mobile 3',
    'DGP-HHV-14h00-16h00',
    'ohm modulo',
  ]
  const validBaseMeterOptions = ['Base+Pointe', '6 cadrans', 'Base Weekend', 'EFFACEMENT_BASE_1']

  if (meterInformation?.elec?.technicalData?.meterOption) {
    // We save original meterOption
    meterInformation.elec.technicalData.tariff_option_enedis = meterInformation.elec.technicalData.meterOption.trimEnd()
  }

  if (meterInformation?.elec?.technicalData?.rawMeterOption) {
    const meterOption = meterInformation.elec.technicalData.rawMeterOption.trimEnd()
    // We save original rawMeterOption
    meterInformation.elec.technicalData.tariff_option_raw_enedis = meterOption
    if (validHPHCMeterOptions.includes(meterOption)) {
      meterInformation.elec.technicalData.rawMeterOption = 'hphc'
    }
    if (validBaseMeterOptions.includes(meterOption)) {
      meterInformation.elec.technicalData.rawMeterOption = 'base'
    }
    return meterInformation
  }

  if (!meterInformation?.elec?.technicalData?.rawMeterOption && meterInformation?.elec?.technicalData?.meterOption) {
    const meterOption = meterInformation.elec.technicalData.meterOption.trimEnd()
    if (meterOption === 'base' || meterOption === 'hphc') {
      meterInformation.elec.technicalData.rawMeterOption = meterOption
    }
  }
  return meterInformation
}

export const retrieveAddressFromEnedis = address => {
  const name = address.name ?? ''
  const streetNumber = address.number ?? ''
  const city = address.city ?? ''
  const zipcode = address.zipcode ?? ''
  const inseeCode = address.inseeCode ?? ''
  if (name.length > 0 && city.length > 0 && zipcode.length > 0 && inseeCode.length > 0) {
    return {
      label: streetNumber + ' ' + name + ' ' + zipcode + ' ' + city,
      address: name,
      streetNumber,
      city,
      inseeCode,
      zipcode,
    }
  }
  return null
}

export const retrieveContractTypeFromEnedis = (contractType, currentContractType) => {
  if (contractType === 'RES' && currentContractType !== 'part') {
    return 'part'
  }
  if (contractType === 'PRO' && currentContractType !== 'pro') {
    return 'pro'
  }
  return null
}

export const retrieveMeterDataFromEnedis = (meterDetails, elecMeter) => {
  const enedisMeterOption = meterDetails.rawMeterOption ? meterDetails.rawMeterOption.toLowerCase() : ''
  const hasSwitchedPower = elecMeter.originalMeterPower ?? false
  const hasSwitchedMeterOption = elecMeter.originalMeterOption ?? false
  const validEnedisMeterPower = parseInt(meterDetails.meterPower ?? '0') > 0
  const toUseMeterPower = validEnedisMeterPower ? meterDetails.meterPower : null
  const meterPowerFromEnedis = toUseMeterPower ?? elecMeter.meterPower ?? ''
  const meterOptionFromEnedis =
    enedisMeterOption === 'base' || enedisMeterOption === 'hphc' ? enedisMeterOption : (elecMeter.meterOption ?? '')
  const enedisMeterState = meterDetails.status ?? ''
  return {
    meterPower: hasSwitchedPower ? elecMeter.meterPower : meterPowerFromEnedis.toString(),
    meterOption: hasSwitchedMeterOption ? elecMeter.meterOption.toLowerCase() : meterOptionFromEnedis.toLowerCase(),
    originalMeterPower: hasSwitchedPower ? meterPowerFromEnedis.toString() : '',
    originalMeterOption: hasSwitchedMeterOption ? meterOptionFromEnedis.toLowerCase() : '',
    meterState: translateMeterState(enedisMeterState),
    meterOpening: meterDetails.serviceOpening ?? '',
    matricule: meterDetails.matricule ?? '',
  }
}

export const translateMeterState = state => {
  switch (state) {
    case 'En service':
      return 'active'
    case 'Résilié':
      return 'close'
    default:
      return '-1'
  }
}

export const retrieveConsumptionDataFromEnedis = (
  yearlyCarValue,
  numberOfDays,
  consumption,
  enedisMeterOption,
  minimumCarForClamp = null,
) => {
  const carValue = parseInt(yearlyCarValue)
  const enedisText =
    "Les données proviennent d'Enedis. Extrapolation sur la base de " + numberOfDays + ' jours connus de consommation.'

  if (
    carValue <= 0 ||
    (enedisMeterOption === 'base' && parseInt(consumption.carBase) > 0) ||
    (enedisMeterOption === 'hphc' && parseInt(consumption.carHp) > 0) ||
    (enedisMeterOption === 'hphc' && parseInt(consumption.carHc) > 0)
  ) {
    return null
  }

  if (enedisMeterOption !== 'base' && enedisMeterOption !== 'hphc') {
    return { error: { meter_option_elec: [`Option tarifaire inconnue: ${enedisMeterOption}`] } }
  }

  const { carBase, carHp, carHc, clamped } = clampEnedisCarToMinimum({
    carValue,
    minimumCar: minimumCarForClamp,
    numberOfDays,
  })
  const carMessage = clamped ? clampCarMessage(minimumCarForClamp) : enedisText

  return {
    consumption: {
      carBase: enedisMeterOption === 'base' ? carBase : 0,
      carHp: enedisMeterOption === 'hphc' ? carHp : 0,
      carHc: enedisMeterOption === 'hphc' ? carHc : 0,
      carBaseOriginal: enedisMeterOption === 'base' ? carBase : 0,
      carHpOriginal: enedisMeterOption === 'hphc' ? carHp : 0,
      carHcOriginal: enedisMeterOption === 'hphc' ? carHc : 0,
      prefilled: {
        carBase: {
          status: enedisMeterOption === 'base',
          message: enedisMeterOption === 'base' ? carMessage : '',
        },
        carHp: {
          status: enedisMeterOption === 'hphc',
          message: enedisMeterOption === 'hphc' ? carMessage : '',
        },
        carHc: {
          status: enedisMeterOption === 'hphc',
          message: enedisMeterOption === 'hphc' ? carMessage : '',
        },
      },
    },
  }
}
